/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiCampaignFromJSON, ApiCampaignToJSON, } from './ApiCampaign';
import { ApiClassificationItemFromJSON, ApiClassificationItemToJSON, } from './ApiClassificationItem';
import { ApiExternalAdGroupFromJSON, ApiExternalAdGroupToJSON, } from './ApiExternalAdGroup';
import { ApiExternalAdStatusFromJSON, ApiExternalAdStatusToJSON, } from './ApiExternalAdStatus';
import { ApiExternalCampaignFromJSON, ApiExternalCampaignToJSON, } from './ApiExternalCampaign';
import { ApiExternalCreativeDataFromJSON, ApiExternalCreativeDataToJSON, } from './ApiExternalCreativeData';
import { ApiExternalEntityStatusFromJSON, ApiExternalEntityStatusToJSON, } from './ApiExternalEntityStatus';
import { ApiLandingPathFromJSON, ApiLandingPathToJSON, } from './ApiLandingPath';
import { ApiServiceFromJSON, ApiServiceToJSON, } from './ApiService';
import { ApiUTMEntityStatusFromJSON, ApiUTMEntityStatusToJSON, } from './ApiUTMEntityStatus';
export function ApiExternalAdFromJSON(json) {
    return ApiExternalAdFromJSONTyped(json, false);
}
export function ApiExternalAdFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'adStatus': !exists(json, 'adStatus') ? undefined : ApiExternalAdStatusFromJSON(json['adStatus']),
        'classificationItems': !exists(json, 'classificationItems') ? undefined : (json['classificationItems'].map(ApiClassificationItemFromJSON)),
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'creativeData': !exists(json, 'creativeData') ? undefined : (json['creativeData'].map(ApiExternalCreativeDataFromJSON)),
        'entityStatus': !exists(json, 'entityStatus') ? undefined : ApiExternalEntityStatusFromJSON(json['entityStatus']),
        'externalAdGroup': !exists(json, 'externalAdGroup') ? undefined : ApiExternalAdGroupFromJSON(json['externalAdGroup']),
        'externalAdGroupId': !exists(json, 'externalAdGroupId') ? undefined : json['externalAdGroupId'],
        'externalCampaign': !exists(json, 'externalCampaign') ? undefined : ApiExternalCampaignFromJSON(json['externalCampaign']),
        'externalCampaignId': !exists(json, 'externalCampaignId') ? undefined : json['externalCampaignId'],
        'externalId': !exists(json, 'externalId') ? undefined : json['externalId'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'landingPath': !exists(json, 'landingPath') ? undefined : ApiLandingPathFromJSON(json['landingPath']),
        'landingPathId': !exists(json, 'landingPathId') ? undefined : json['landingPathId'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'projectId': !exists(json, 'projectId') ? undefined : json['projectId'],
        'qsParams': !exists(json, 'qsParams') ? undefined : json['qsParams'],
        'service': !exists(json, 'service') ? undefined : ApiServiceFromJSON(json['service']),
        'smartLinkUrl': !exists(json, 'smartLinkUrl') ? undefined : json['smartLinkUrl'],
        'splitCampaign': !exists(json, 'splitCampaign') ? undefined : ApiCampaignFromJSON(json['splitCampaign']),
        'splitCampaignId': !exists(json, 'splitCampaignId') ? undefined : json['splitCampaignId'],
        'status': !exists(json, 'status') ? undefined : ApiUTMEntityStatusFromJSON(json['status']),
        'syncId': !exists(json, 'syncId') ? undefined : json['syncId'],
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
    };
}
export function ApiExternalAdToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'adStatus': ApiExternalAdStatusToJSON(value.adStatus),
        'classificationItems': value.classificationItems === undefined ? undefined : (value.classificationItems.map(ApiClassificationItemToJSON)),
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'creativeData': value.creativeData === undefined ? undefined : (value.creativeData.map(ApiExternalCreativeDataToJSON)),
        'entityStatus': ApiExternalEntityStatusToJSON(value.entityStatus),
        'externalAdGroup': ApiExternalAdGroupToJSON(value.externalAdGroup),
        'externalAdGroupId': value.externalAdGroupId,
        'externalCampaign': ApiExternalCampaignToJSON(value.externalCampaign),
        'externalCampaignId': value.externalCampaignId,
        'externalId': value.externalId,
        'id': value.id,
        'landingPath': ApiLandingPathToJSON(value.landingPath),
        'landingPathId': value.landingPathId,
        'name': value.name,
        'projectId': value.projectId,
        'qsParams': value.qsParams,
        'service': ApiServiceToJSON(value.service),
        'smartLinkUrl': value.smartLinkUrl,
        'splitCampaign': ApiCampaignToJSON(value.splitCampaign),
        'splitCampaignId': value.splitCampaignId,
        'status': ApiUTMEntityStatusToJSON(value.status),
        'syncId': value.syncId,
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
    };
}
